import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { DetailsLayout, Text } from '../../common';

function SurgeryDetails({ date, type, hospital, notes }) {
  const surgeryDate = date ? format(date, 'M/D/YYYY') : '';

  return (
    <DetailsLayout heading={type}>
      {!!surgeryDate && <div>{surgeryDate}</div>}
      {hospital && <div>Hospital: {hospital}</div>}
      {notes && (
        <div>
          <Text>Notes: </Text>
          <Text>{notes}</Text>
        </div>
      )}
    </DetailsLayout>
  );
}

SurgeryDetails.propTypes = {
  date: PropTypes.string,
  hospital: PropTypes.string,
  notes: PropTypes.string,
  type: PropTypes.string,
};

export default SurgeryDetails;



// WEBPACK FOOTER //
// ./src/modules/SurgeryPage/components/SurgeryDetails.js